import { createContext, useContext } from 'react';
export const navigationData = {
    homeArmstrong: {
        href: '/discover/updates',
    },
    discover: {
        href: '/network-home',
    },
    meV2: {
        href: '/you',
    },
};
export const XingFrameContext = createContext(undefined);
export function useFrameContext() {
    const frameContext = useContext(XingFrameContext);
    if (!frameContext)
        throw new Error('Missing XingFrame module');
    return frameContext;
}
//# sourceMappingURL=xing-frame.js.map